import { ClinicalTreatmentTile } from "./ClinicalTreatmentTile"
import { useFlags } from "launchdarkly-react-client-sdk"
import { CareTeamHeader } from "#/components/care-team/CareTeamHeader"
import { CareTeamSpecialistsSection } from "#/components/care-team/CareTeamSpecialistsSection"
import { CarrotCompanionCareTeamSection } from "#/components/care-team/CarrotCompanionCareTeamSection"
import { OtherWaysToContactCarrotTile } from "#/components/care-team/OtherWaysToContactCarrotTile"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { FullScreenLoading } from "#/components/read/shared/FullScreenLoading"
import { PageLayout } from "#/features/global-ui/page-layout"
import { ProgramType } from "#/lib/carrot-api/types/Benefit"
import { Title } from "#/services/page-title/Title"
import { Stack, Divider } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import React from "react"

export const CareTeamPage = (): JSX.Element => {
  const { data: benefit, isLoading: isBenefitLoading } = useBenefit()
  const intl = useIntl()
  const { telemedicineEnterprisePayments } = useFlags()
  const isProgramProOrCore =
    benefit && (benefit.program.type === ProgramType.PRO || benefit.program.type === ProgramType.CORE)
  if (isBenefitLoading) {
    return <FullScreenLoading />
  }
  return (
    <>
      <Title title={intl.formatMessage({ defaultMessage: "Care Team" })} />
      <PageLayout
        header={<CareTeamHeader />}
        variant="sidebar"
        sidebar={
          <Stack gap={(theme) => theme.tokens.spacing.xl}>
            {/* This is a placeholder for the purpose of testing. It will be replaced with the actual card and other redesigns on this page in the future. */}
            {telemedicineEnterprisePayments === true && <ClinicalTreatmentTile />}
            <OtherWaysToContactCarrotTile />
          </Stack>
        }
      >
        <Stack divider={<Divider />} gap={(theme) => theme.tokens.spacing.xl}>
          {isProgramProOrCore && <CareTeamSpecialistsSection />}
          <CarrotCompanionCareTeamSection />
        </Stack>
      </PageLayout>
    </>
  )
}
